import Typography from '@mui/material/Typography';
import { FeatureFlag, ResolverTag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import { StarsButton, Translation, usePostMessage } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import useOpenDocumentVerification from '@swf/core/hooks/useOpenDocumentVerification';
import useWizardExit from '@swf/core/hooks/useWizardExit';
import { select } from '@swf/core/store';

import trVideoMobile from '../../../..//assets/video/tr-video-mobile.mp4';
import trScreenVideo from '../../../../assets/video/tr-screen-video.mp4';
import Prompt from '../../../Prompt/Prompt';

import {
  TXTCLI_Extra_verification_required,
  TXTCLI_Upload_Documents,
  TXTCLI_WeXre_still_having_trouble_ver_ELL,
  TXTSRV_1X_A_copy_of_your_driverXs_lic_ELL,
  TXTSRV_2X_A_copy_of_your_Social_Secur_ELL,
  TXTWCL_Upload_Later
} from './RMFExtraVerificationTransition.messages.json';
import styles from './RMFExtraVerificationTransition.scss';

interface Props {
  onClose: () => void;
}

const RMFExtraVerificationTransition: React.FC<Props> = ({ onClose }) => {
  const isMobile = useSelector(select.device.isMobile);
  const video = isMobile ? trVideoMobile : trScreenVideo;
  const isDesktopEmbedded = useSelector(select.device.isDesktopEmbedded);
  const isMobileEmbedded = useSelector(select.device.isMobileEmbedded);
  const isUSPAEnhancedFlow = useFeature(FeatureFlag.SwcUSPAEnhancedFlow);
  const exitWizard = useWizardExit();
  const postMessage = usePostMessage();
  const openWindowContactSupport = useOpenDocumentVerification({
    resolverTag: ResolverTag.SubmitDocumentsVerifications,
    openTab: true
  });

  const handleDocumentsUpload = () => {
    openWindowContactSupport();
    if (!isMobileEmbedded) {
      if (isDesktopEmbedded) {
        postMessage('close');
        window.close();
      } else {
        exitWizard();
      }
    }
  };

  return (
    <Prompt
      title={{ translation: TXTCLI_Extra_verification_required }}
      onClose={onClose}
      video={video}
      variant="info"
    >
      <Typography>
        <Translation {...TXTCLI_WeXre_still_having_trouble_ver_ELL} />
      </Typography>
      <Typography>
        <Translation {...TXTSRV_1X_A_copy_of_your_driverXs_lic_ELL} />
        <br />
        <Translation {...TXTSRV_2X_A_copy_of_your_Social_Secur_ELL} />
      </Typography>
      <div className={styles.actionButtons}>
        <StarsButton
          variant="primary"
          translation={TXTCLI_Upload_Documents}
          onClick={handleDocumentsUpload}
        />
        <StarsButton
          className={!isUSPAEnhancedFlow ? styles.uploadLater : ''}
          variant={isUSPAEnhancedFlow ? 'secondary' : 'text'}
          translation={TXTWCL_Upload_Later}
          onClick={exitWizard}
        />
      </div>
    </Prompt>
  );
};

export default RMFExtraVerificationTransition;
